var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTextoBlanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 196.543,
    height: 114.293,
    viewBox: "0 0 196.543 114.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGOTIPO_PRINCIPAL_POSITIVO_B-N_RGB",
    transform: "translate(-207 -173.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3",
    "data-name": "Grupo 3",
    transform: "translate(308.404 173.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M427.76,208.37V173.23h11.167v34.46c0,3.473.749,4.5,2.724,4.5,2.113,0,2.655-.955,2.655-4.5V173.23h11.171v35.14c0,10.285-5.177,14.644-13.826,14.644C432.6,223.013,427.76,218.654,427.76,208.37Z",
    transform: "translate(-427.76 -173.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M511.225,222.265H500.26V173.23h13.826c9.945,0,13.9,3.95,13.9,12.26v8.649c0,8.241-3.95,13.077-13.9,13.077h-2.862Zm0-24.791h2.246c2.177,0,3.271-1.226,3.271-3.61v-7.9c0-2.315-1.02-3.4-3.2-3.4h-2.315Z",
    transform: "translate(-466.958 -173.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M571.13,222.265V173.23h10.009l8.649,23.973.749,2.724-.2-4.428V173.23h10.078v49.035h-9.807l-8.852-23.973-.818-2.793.271,4.837v21.929H571.13Z",
    transform: "translate(-505.274 -173.23)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(207 173.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5",
    "data-name": "Grupo 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    "data-name": "Grupo 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M248.423,173.23V287.344H231.745V203.735l-.473.436A136.3,136.3,0,0,1,207,222.375v-18.87a118.992,118.992,0,0,0,13.036-10.556,120.628,120.628,0,0,0,17.019-19.72h11.369Z",
    transform: "translate(-207 -173.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M352.073,203.505v18.87a136.687,136.687,0,0,1-24.272-18.2l-.473-.436v83.609H310.65V173.23h11.369a120.849,120.849,0,0,0,17.019,19.72A118.126,118.126,0,0,0,352.073,203.505Z",
    transform: "translate(-263.039 -173.23)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(310.375 235.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M432.05,318.255V308.94h2.379v9.168c0,1.272.326,1.759,1.181,1.759s1.18-.473,1.18-1.759V308.94h2.361v9.315c0,2.724-1.254,3.9-3.542,3.9C433.249,322.16,432.05,320.979,432.05,318.255Z",
    transform: "translate(-432.05 -308.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M451.38,321.968V308.95h2.09l2.995,7.336.455,1.47L456.791,316V308.95h2.122v13.018h-2.035l-3.068-7.391-.455-1.562.147,1.943v7.01H451.38Z",
    transform: "translate(-442.501 -308.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M471.11,319.744h1.525v-8.626H471.11V308.94h5.282v2.177H474.9v8.626h1.488v2.214H471.11Z",
    transform: "translate(-453.168 -308.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M484.75,308.94h2.4l1.543,7.772.129,1.906.129-1.906,1.507-7.772h2.379L490,321.958h-2.361Z",
    transform: "translate(-460.543 -308.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M504.95,321.968V308.95h6.082v2.122H507.27v3.234h3.3v2.145h-3.3v3.321h3.868v2.2H504.95Z",
    transform: "translate(-471.464 -308.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M523.9,321.968H521.63V308.95h3.5c2.453,0,3.468.946,3.468,3.105v1.562a2.118,2.118,0,0,1-1.378,2.288c.946.308,1.254.978,1.254,2.269v2.94a1.1,1.1,0,0,0,.344.854h-2.471a1.162,1.162,0,0,1-.234-.873v-2.816c0-.928-.253-1.291-1.236-1.291H523.9v4.979Zm0-7.046h1.107c.928,0,1.291-.418,1.291-1.291v-1.452c0-.854-.363-1.236-1.309-1.236H523.9Z",
    transform: "translate(-480.482 -308.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M539.61,318.549V316.8h2.435v1.709c0,.836.289,1.323,1.236,1.323.854,0,1.144-.528,1.144-1.254v-.671a1.508,1.508,0,0,0-.289-.928,5.174,5.174,0,0,0-1.778-1.217,8.721,8.721,0,0,1-1.217-.744,3.064,3.064,0,0,1-1.378-2.706v-.542c0-2.017,1.107-3.234,3.45-3.234s3.395,1.144,3.395,3.05V313H544.3v-1.272c0-.854-.308-1.236-1.107-1.236-.781,0-1.089.51-1.089,1.291v.363a1.189,1.189,0,0,0,.289.836,5.686,5.686,0,0,0,1.741,1.162c.418.216.818.473,1.236.744a3.114,3.114,0,0,1,1.4,2.742v1c0,2.072-1.181,3.3-3.523,3.3C540.538,321.944,539.61,320.763,539.61,318.549Z",
    transform: "translate(-490.203 -308.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M557.6,319.744h1.525v-8.626H557.6V308.94h5.282v2.177h-1.488v8.626h1.488v2.214H557.6Z",
    transform: "translate(-499.93 -308.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M575.778,308.94a4.79,4.79,0,0,1,2.017.4c1.162.51,1.888,1.617,1.888,3.468v5.282a4.159,4.159,0,0,1-.51,2.214,3.655,3.655,0,0,1-3.413,1.654h-3.34V308.94Zm-1.015,10.951h.909c1,0,1.58-.6,1.58-2.017v-4.9c0-1.433-.6-2.017-1.6-2.017h-.891Z",
    transform: "translate(-507.942 -308.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M592.516,320.043l-.363,1.925H589.81l2.885-13.018h2.343L598,321.968h-2.343l-.381-1.925Zm2.361-2.053-.854-4.341-.147-1.814-.147,1.814-.818,4.341Z",
    transform: "translate(-517.344 -308.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M613.488,308.94a4.791,4.791,0,0,1,2.017.4c1.162.51,1.888,1.617,1.888,3.468v5.282a4.159,4.159,0,0,1-.51,2.214,3.655,3.655,0,0,1-3.413,1.654H610.13V308.94Zm-1.015,10.951h.909c1,0,1.58-.6,1.58-2.017v-4.9c0-1.433-.6-2.017-1.6-2.017h-.891Z",
    transform: "translate(-528.33 -308.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M434.516,364.128H432.21V351.11h3.431c2.522,0,3.615.983,3.615,3.284v2.214c0,2.145-1.052,3.431-3.578,3.431h-1.162Zm0-6.137h1.033c.928,0,1.36-.492,1.36-1.433v-2.085c0-1-.418-1.36-1.36-1.36h-1.033Z",
    transform: "translate(-432.137 -331.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M453.019,364.128H450.75V351.11h3.5c2.453,0,3.468.946,3.468,3.105v1.562a2.118,2.118,0,0,1-1.378,2.288c.946.308,1.254.978,1.254,2.269v2.94a1.1,1.1,0,0,0,.345.854h-2.471a1.162,1.162,0,0,1-.234-.873v-2.816c0-.928-.253-1.291-1.236-1.291h-.978v4.979Zm0-7.042h1.107c.928,0,1.291-.418,1.291-1.291v-1.452c0-.854-.363-1.236-1.309-1.236h-1.089Z",
    transform: "translate(-442.16 -331.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M468.7,361.914h1.525v-8.626H468.7V351.11h5.282v2.177h-1.488v8.626h1.488v2.214H468.7Z",
    transform: "translate(-451.865 -331.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M482.33,351.11h2.4l1.543,7.772.129,1.906.129-1.906,1.507-7.772h2.379l-2.834,13.018h-2.361Z",
    transform: "translate(-459.234 -331.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M501.365,362.2,501,364.128H498.66l2.885-13.018h2.343l2.958,13.018H504.5l-.381-1.925Zm2.361-2.053-.854-4.341-.147-1.814-.147,1.814-.818,4.341Z",
    transform: "translate(-468.063 -331.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M522.338,351.11a4.79,4.79,0,0,1,2.016.4c1.162.51,1.888,1.617,1.888,3.468v5.282a4.159,4.159,0,0,1-.51,2.214,3.656,3.656,0,0,1-3.413,1.654H518.98V351.11Zm-1.015,10.946h.909c1,0,1.58-.6,1.58-2.017v-4.9c0-1.433-.6-2.017-1.6-2.017h-.891Z",
    transform: "translate(-479.049 -331.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M539.076,362.2l-.363,1.925H536.37l2.885-13.018H541.6l2.958,13.018h-2.343l-.381-1.925Zm2.361-2.053-.854-4.341-.147-1.814-.147,1.814-.818,4.341Z",
    transform: "translate(-488.451 -331.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M435.578,393.27a4.791,4.791,0,0,1,2.017.4c1.162.51,1.888,1.617,1.888,3.468v5.282a4.159,4.159,0,0,1-.51,2.214,3.655,3.655,0,0,1-3.413,1.654H432.22V393.27Zm-1.02,10.951h.909c1,0,1.58-.6,1.58-2.017v-4.9c0-1.433-.6-2.017-1.6-2.017h-.891Z",
    transform: "translate(-432.142 -354.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M451.7,406.288V393.27h6.082v2.122h-3.757v3.234h3.3v2.145h-3.3v3.321h3.868v2.2H451.7Z",
    transform: "translate(-442.674 -354.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M468.38,393.27h2.4v10.675h3.486v2.343H468.38Z",
    transform: "translate(-451.692 -354.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M492.89,406.288V393.27h2.09l2.995,7.336.455,1.47-.129-1.759V393.27h2.122v13.018h-2.035L495.32,398.9l-.455-1.562.147,1.943v7.01H492.89Z",
    transform: "translate(-464.944 -354.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M512.97,402.336V396.87c0-2.669,1.47-3.96,3.757-3.96s3.757,1.291,3.757,3.96v5.466c0,2.724-1.47,3.96-3.757,3.96C514.385,406.3,512.97,405.078,512.97,402.336Zm5.085-.179v-5.172c0-1.36-.381-1.98-1.327-1.98-.978,0-1.323.634-1.323,1.98v5.172c0,1.346.344,1.961,1.323,1.961C517.674,404.118,518.055,403.5,518.055,402.157Z",
    transform: "translate(-475.8 -354.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M535.279,406.288H533.01V393.27h3.5c2.453,0,3.468.946,3.468,3.105v1.562a2.119,2.119,0,0,1-1.378,2.288c.946.308,1.254.978,1.254,2.269v2.94a1.1,1.1,0,0,0,.345.854h-2.471a1.162,1.162,0,0,1-.234-.873V402.6c0-.928-.253-1.291-1.236-1.291h-.978v4.979Zm0-7.042h1.107c.928,0,1.291-.418,1.291-1.291V396.5c0-.854-.363-1.236-1.309-1.236h-1.089Z",
    transform: "translate(-486.635 -354.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M554.8,406.282h-2.343V395.405H550.32V393.26h6.647v2.145h-2.159v10.877Z",
    transform: "translate(-495.994 -354.345)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31",
    "data-name": "Trazado 31",
    d: "M567.76,406.288V393.27h6.082v2.122h-3.757v3.234h3.3v2.145h-3.3v3.321h3.868v2.2H567.76Z",
    transform: "translate(-505.423 -354.35)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextoBlanco);
export default __webpack_public_path__ + "static/media/LogoTextoBlanco.4d0c3f92d7dd0fa47e377c3a2653a7ec.svg";
export { ForwardRef as ReactComponent };